import { gsap } from "gsap";
import { CSSPlugin } from "gsap/CSSPlugin";
gsap.registerPlugin(CSSPlugin);

$(function () {
  const $chart = $('.js-circle-chart-scale');
  $chart.each( (i, el) => {
    const $circle = $(el).find('.js-circle-chart-bar')
    let val = parseInt($(el).attr('data-progress'));
    
    if (isNaN(val)) {
      val = 0; 
    }
    else{
      var r = $circle.attr('r');
      var c = Math.PI*(r*2);
      
      if (val < 0) { val = 0;}
      if (val > 100) { val = 100;}
      
      var pct = ((100-val)/100)*c;
      
      gsap.to($circle, { delay: 0, duration: 1, strokeDashoffset: pct });
    }
  } )
});
